import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { getRequestOnServer } from '#src/functions/getRequestOnServer.ts';
import { VenuePage } from '#src/pages/VenuePage/index.ts';
import { ssrWhenNotAuthenticated } from '#src/utils/tanstackRouterUtil.ts';

export const Route = createFileRoute('/{-$locale}/venue_/$venueId')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { locale, venueId } = params;
    const request = getRequestOnServer();
    await queryClient.ensureQueryData(venueQueryOptions({ locale, request, venueId }));
  },
  ssr: ssrWhenNotAuthenticated
});

function RouteComponent() {
  const { locale, venueId } = Route.useParams();

  const query = useSuspenseQuery(venueQueryOptions({ locale, venueId }));
  const venue = query.data.data;

  return <VenuePage venue={venue} />;
}

function venueQueryOptions({
  locale,
  request,
  venueId
}: {
  locale?: string;
  request?: Request;
  venueId: string;
}) {
  return getReactQueryOptions(
    publicApiQueryClient.venues.get,
    { params: { id: venueId } },
    { context: { locale, request } }
  );
}
